import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=79df31c9&scoped=true&"
import script from "./InvoiceItem.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=79df31c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79df31c9",
  null
  
)

export default component.exports